import { Directive, TemplateRef, inject, input } from '@angular/core';
import type { GridCellContext } from '../core/interfaces/grid-context.types';

/**
 * Marca um `ng-template` como visualização customizada de célula.
 *
 * Uso dentro de `<company-column>`:
 * ```html
 * <ng-template companyCellDef let-row="row">...</ng-template>
 * ```
 *
 * Uso como override em `<company-table>` (por campo):
 * ```html
 * <ng-template companyCellDef field="_compare" let-row="row">...</ng-template>
 * ```
 */
@Directive({ selector: '[companyCellDef]' })
export class CompanyCellDefDirective<T = unknown> {
  /** Quando definido, associa o template a uma coluna do modo produtivo (`company-table`). */
  readonly field = input<string>();
  readonly template = inject(TemplateRef<GridCellContext<T>>);
}
